import ComponentPdfPage from './ComponentPdfPage';
export default ComponentPdfPage;
